import { useState } from 'react'

export const useTabsState = (defaultTab: number = 0) => {
  const [activeTab, setActiveTab] = useState(defaultTab)

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  return {
    activeTab,
    setActiveTab,
    handleTabChange,
  }
}
